import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack, Divider } from "@material-ui/core";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import apiPbx from '../../api/pbx';
import { useSnackbar } from 'notistack5';
import { Icon } from '@iconify/react';

export default function DialogPlayRecord({ isOpenModalPlayRecord, handleCloseModalPlayRecord, callId }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [urlRecord, setUrlRecord] = useState('');

  const checkRecord = async () => {
    try {
      const res = await apiPbx.find_record({ 'callid': callId });
      if (res.status == 200) {
        if (res.data.data == null) {
          const res1 = await apiPbx.find_record({ 'callid': callId });
          setUrlRecord(res1.data.data.data.ogg);
          setIsLoading(false);
        } else {
          setUrlRecord(res.data.data.data.ogg);
          setIsLoading(false);
        }
      }
    } catch (error) {
      enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
    }
  };
  useEffect(() => {
    checkRecord();
  }, []);


  return (
    <>
      <Dialog open={isOpenModalPlayRecord} onClose={handleCloseModalPlayRecord} fullWidth>
        <DialogTitle>
          <Typography sx={{ color: '#303187', fontSize: '20px', fontWeight: 700 }}>Nghe ghi âm</Typography>
        </DialogTitle>
        <Divider sx={{ mt: '20px' }} />
        <DialogContent sx={{ mt: 3 }}>
          {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> */}
          {isLoading ?
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Stack direction={'column'} spacing={1}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress />
                </Box>
                <Typography>Đang tải bản ghi âm lên...</Typography>
              </Stack>
            </Box> : <AudioPlayer src={urlRecord} autoPlay />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModalPlayRecord} color="primary" variant="contained" startIcon={<Icon icon="ep:close-bold" />}>
            Đóng
          </Button>
        </DialogActions>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ height: "15px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
          <Box sx={{ height: "15px", width: '40%', background: "red", clipPath: 'polygon(0 0, 93% 0, 100% 100%, 0 100%)' }}> </Box>
        </Box>
      </Dialog>
    </>
  );
}
